import React from 'react'

// Components
import Modal from 'components/Modal'
import Button from 'components/Button'

// Styles
import { ModalBody } from './Confirm2FADisabledModal.styles'

// Types
import { ModalInjectedProps } from 'containers/ModalManager'

interface Confirm2FADisabledModalProps extends ModalInjectedProps {}

/**
 *
 * This modal renders a confirmation message that the  2FA was disabled
 *
 * Used in TwoFactorAuthentcationPanel
 */
const Confirm2FADisabledModal: React.FC<Confirm2FADisabledModalProps> = ({
  hideModal,
}) => {
  const handleConfirm = () => {
    hideModal()
  }

  return (
    <Modal title="Two-Factor Authentication Disabled" onCancel={hideModal}>
      <ModalBody>
        Two-factor authentication (2FA) has been disabled on your profile.
      </ModalBody>
      <Modal.Footer>
        <Button variant="primary" onClick={handleConfirm} smaller>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Confirm2FADisabledModal
